var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"mb-10",attrs:{"src":_vm.computedSrc,"max-height":"100","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }